import { atom as e, map as t } from "nanostores";
// src/global-state.ts
var n = e(null);
function r() {
	if (window.__hydra_copilot__ != null && "copilotInstructions" in window.__hydra_copilot__) return window.__hydra_copilot__;
	let e = {
		copilotInstructions: t({}),
		copilotTools: t({}),
		copilotContext: t({}),
		currentCopilotSession: n
	};
	return Object.assign(window, { __hydra_copilot__: e }), e;
}
var { copilotInstructions: i, copilotTools: a, copilotContext: o } = r();
function s(e) {
	if (!window.__hydra_copilot__) throw Error("Copilot global state is not initialized.");
	Object.assign(window.__hydra_copilot__, e);
}
function c(e) {
	n.set(e);
}
function l() {
	return Math.random().toString(36).substring(2, 15);
}
function u(e) {
	let t = l();
	return i.setKey(t, e), () => {
		i.setKey(t, void 0);
	};
}
function d(e) {
	return a.setKey(e.name, e), () => {
		a.setKey(e.name, void 0);
	};
}
function f(e) {
	let t = l();
	return o.setKey(t, e), () => {
		o.setKey(t, void 0);
	};
}
export { f as addCopilotContext, u as addCopilotInstruction, d as addCopilotTool, o as copilotContext, i as copilotInstructions, a as copilotTools, n as currentCopilotSession, r as initializeGlobalState, s as setCopilotConfig, c as setCurrentSession, l as uniqueId };
